import React, { useState } from 'react'
import _helpers from '@toasttab/shared/src/globals/_helpers'
import heapAnalytics from '@toasttab/shared/utils/heapAnalytics'
import MainLayout from '@toasttab/shared/src/layout/MainLayout'
import DataHero from '@toasttab/otl/src/components/MDS/DataHero/DataHero'
import Hero from '@toasttab/otl/src/components/MDS/Hero/Hero'
import Article from '@toasttab/otl/src/components/MDS/Article/Article'
import DataArticle from '@toasttab/otl/src/components/MDS/DataArticle/DataArticle'
import RelatedArticlesSlider from '@toasttab/otl/src/components/MDS/Slider/RelatedArticlesSlider'
import {
  AuthorProps,
  ReviewerProps
} from '@toasttab/otl/src/components/Byline/Byline.d'
import SubscribeCTA from '@toasttab/otl/src/components/MDS/CTA/SubscribeCTA'
import Footnotes from '@toasttab/shared/src/components/organisms/Footnotes/Footnotes'
import { OTLContext } from '@toasttab/shared/src/context/OTLContext'
import { useSiteMetadata } from '@toasttab/otl/src/hooks/use-site-metadata'
import {
  getEntryImages,
  getImage,
  getLanguageByCountryCode,
  getSiteIdByLanguageCode
} from '@toasttab/shared/src/utils/siteUtils'
import {
  PageContextProps,
  PageContextProvider
} from '@toasttab/shared/src/hooks/usePageContext'
import { useI18next } from '@toasttab/shared/src/hooks/useI18next'

const MDSEntry = (props: any) => {
  const { language, region } = useI18next()
  const siteId = getSiteIdByLanguageCode(getLanguageByCountryCode(language))

  let entry = props.entries.regions.find((x: any) => x.country === region)
  entry.siteId = siteId

  const [mdsState, setMdsState] = useState({
    isArticle: true,
    isMinimal: false,
    isPreview: props.pageContext.preview
  })
  const siteMetadata = useSiteMetadata()
  // Begin => OC-227 : Pausing Test for OC-148 (https://toasttab.atlassian.net/browse/OC-227 & https://toasttab.atlassian.net/browse/OC-148)
  /*
    useEffect(() => {
      const mobileStickyCtaCookie = _helpers.getCookie('X-EdgeOptimize-mtg-cro_mobile_sticky_cta')

      if (mobileStickyCtaCookie) {
        if (mobileStickyCtaCookie == 'VARIANT') {
          setMdsState({ isArticle: true, isMinimal: true })
        }
        heapAnalytics({ cro_mobile_sticky_cta: mobileStickyCtaCookie })
      }
    }, [])
  */
  // End => OC-227 : Pausing Test for OC-148

  const author: AuthorProps = {
    name: entry.blogAuthor && entry.blogAuthor.title,
    bio: entry.blogAuthor && entry.blogAuthor.bio.bio,
    headshot: entry.blogAuthor && getImage(entry.blogAuthor.indexThumbnail)
  }
  const emailFormEntry = props.data.allContentfulFormPage.nodes[0]
  const regionEmailFormEntry = emailFormEntry.regions.find(
    (x: any) => x.country === region
  )
  const formCategories = regionEmailFormEntry.content
  const heroTitle = entry.hero?.headline
  const shortDescription = entry.hero?.description?.description
  const entryImages = getEntryImages(entry.hero)

  const heroImage: any = {
    title:
      Boolean(entryImages.length) &&
      Boolean(entryImages[0].heroImage) &&
      Boolean(entryImages[0].heroImage.length)
        ? entryImages[0].heroImage[0].title
        : '',
    src:
      Boolean(entryImages.length) &&
      Boolean(entryImages[0].heroImage) &&
      Boolean(entryImages[0].heroImage.length)
        ? entryImages[0].heroImage[0].optimizedImages.src
        : '',
    avif:
      Boolean(entryImages.length) &&
      Boolean(entryImages[0].heroImage) &&
      Boolean(entryImages[0].heroImage.length)
        ? entryImages[0].heroImage[0].optimizedImages?.srcAvif
        : ''
  }
  const reviewer: ReviewerProps = {
    name: entry.expertReviewer && entry.expertReviewer[0]?.fullName,
    jobTitle: entry.expertReviewer && entry.expertReviewer[0]?.jobTitle,
    bio: entry.expertReviewer && entry.expertReviewer[0]?.bio,
    headshot:
      entry.expertReviewer && getImage(entry.expertReviewer[0]?.headshot),
    websiteLabel: entry.expertReviewer && entry.expertReviewer[0]?.websiteName,
    websiteUrl: entry.expertReviewer && entry.expertReviewer[0]?.websiteUrl
  }

  const globalSettings = props.data.allContentfulGlobalSettings?.edges[0]?.node
  const context: PageContextProps = {
    globalSettings,
    packageName: 'onTheLine',
    region: region as PageContextProps['region']
  }

  const mainFooter = props.data.allContentfulGlobalPageFooter?.edges?.filter(
    (f: any) => f.node.internalName === 'Main Site Footer'
  )[0].node
  const footerContent = mainFooter?.pageFooter.filter(
    (f: any) => f.country === region
  )[0].footerContent

  const isDataPage = props.path.includes('/blog/data/')

  return (
    <PageContextProvider value={context}>
      <OTLContext.Provider value={mdsState}>
        <MainLayout
          currentLanguage={entry.language}
          footerContent={footerContent}
          localizedEntries={entry.localized}
          packageName='onTheLine'
          siteId={entry.siteId}
        >
          {isDataPage ? (
            <>
              <DataHero
                author={author}
                description={shortDescription}
                expertReviewer={reviewer}
                heading={heroTitle}
                heroImage={entry.hero.imageComponent || heroImage}
              />
              <DataArticle entry={entry} formCategories={formCategories} />
            </>
          ) : (
            <>
              <Hero
                author={author}
                description={shortDescription}
                expertReviewer={reviewer}
                heading={heroTitle}
                heroImage={heroImage}
              />
              <Article entry={entry} formCategories={formCategories} />
            </>
          )}
          <RelatedArticlesSlider onTheLineModules={entry.content} />
          {!isDataPage && <SubscribeCTA formCategories={formCategories} />}
          <Footnotes />
        </MainLayout>
      </OTLContext.Provider>
    </PageContextProvider>
  )
}

export default MDSEntry
